export const UPPERCASE_XL = 'XL';
export const UPPERCASE_KING = 'King';
export const UNDERSCORE = '_';

export const extractTextFromHtml = (htmlString: string) =>
  htmlString.replace(/<[^>]*>/g, '');
